let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gfnHV")).then(() => parcelRequire('eT9yw'));